import { svgIcon } from "@bitwarden/components";

export const DevicesIcon = svgIcon`
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 120 100">
    <path
      class="tw-fill-art-primary"
      fill-rule="evenodd"
      d="M41.212 87.309c0-.335.271-.606.606-.606H76.97a.606.606 0 0 1 0 1.212H41.818a.606.606 0 0 1-.606-.606Z"
      clip-rule="evenodd"
    />
    <path
      class="tw-fill-art-primary"
      fill-rule="evenodd"
      d="M53.176 87.31V76.542h1.212V87.31h-1.212Zm12.103 0V76.542h1.212V87.31h-1.212Z"
      clip-rule="evenodd"
    />
    <path
      class="tw-fill-art-primary"
      fill-rule="evenodd"
      d="M16.363 29.733a8.485 8.485 0 0 1 8.485-8.485h70.303a8.485 8.485 0 0 1 8.485 8.485v3.637h-2.424v-3.637a6.06 6.06 0 0 0-6.06-6.06H24.847a6.06 6.06 0 0 0-6.06 6.06v9.697h-2.425v-9.697Zm9.091 44.849H76.97v2.424H25.454v-2.424Z"
      clip-rule="evenodd"
    />
    <path
      class="tw-fill-art-accent"
      fill-rule="evenodd"
      d="M21.212 30.34c0-2.344 1.9-4.243 4.242-4.243h69.091c2.343 0 4.243 1.9 4.243 4.242v3.03h-1.212v-3.03a3.03 3.03 0 0 0-3.03-3.03H25.453a3.03 3.03 0 0 0-3.03 3.03v9.091h-1.212v-9.09Zm4.242 40.605H76.97v1.212H25.454v-1.212Z"
      clip-rule="evenodd"
    />
    <path
      class="tw-fill-art-primary"
      fill-rule="evenodd"
      d="M75.758 38.218a6.06 6.06 0 0 1 6.06-6.06h32.122a6.06 6.06 0 0 1 6.06 6.06v48.485a6.06 6.06 0 0 1-6.06 6.06H81.818a6.06 6.06 0 0 1-6.06-6.06V38.218Zm6.06-3.636a3.636 3.636 0 0 0-3.636 3.636v48.485a3.636 3.636 0 0 0 3.636 3.636h32.122a3.636 3.636 0 0 0 3.636-3.636V38.218a3.636 3.636 0 0 0-3.636-3.636H81.818Z"
      clip-rule="evenodd"
    />
    <path
      class="tw-fill-art-accent"
      d="M99.394 87.31a1.212 1.212 0 1 1-2.424 0 1.212 1.212 0 0 1 2.424 0Z"
    />
    <path
      class="tw-fill-art-primary"
      fill-rule="evenodd"
      d="M20.606 40.642H6.061a3.636 3.636 0 0 0-3.637 3.636V80.64a3.636 3.636 0 0 0 3.637 3.637h14.545a3.636 3.636 0 0 0 3.636-3.637V44.278a3.636 3.636 0 0 0-3.636-3.636ZM6.061 38.217A6.06 6.06 0 0 0 0 44.277v36.364a6.06 6.06 0 0 0 6.06 6.061h14.546a6.06 6.06 0 0 0 6.06-6.06V44.277a6.06 6.06 0 0 0-6.06-6.06H6.061Z"
      clip-rule="evenodd"
    />
    <path
      class="tw-fill-art-accent"
      fill-rule="evenodd"
      d="M12.345 43.556c0-.334.272-.606.606-.606h.753a.606.606 0 1 1 0 1.212h-.753a.606.606 0 0 1-.606-.606Z"
      clip-rule="evenodd"
    />
  </svg>
`;
